import React from "react";
import "./Header.css";

function Header({
  navItems = [],
  currentPath = "/",
  onNavigate = () => {},
  onMenuToggle = () => {},
  onSidebarToggle = () => {},
}) {

  const handleLogoClick = () => {
    onNavigate("/");
  };

  const handleNavigate = (path) => {
    if (path !== currentPath) {
      onNavigate(path);
    }
  };

  return (
    <header className="header">
      <div className="header__inner">

        {/* Mobile menu button */}
        <button
          type="button"
          className="header__menu-button"
          aria-label="Open navigation menu"
          onClick={onMenuToggle}
        >
          ☰
        </button>

        {/* Brand / Logo */}
        <button
          type="button"
          className="header__brand"
          onClick={handleLogoClick}
          aria-label="Go to CarbCareUSA homepage"
        >
          <span className="header__brand-main">CarbCareUSA</span>
          <span className="header__brand-sub">
            Marine & Automotive Carburetors
          </span>
        </button>

        {/* Navigation */}
        <nav className="header__nav" aria-label="Primary navigation">
          {navItems.map((item) => {
            const isActive = currentPath === item.path;

            return (
              <button
                key={item.path}
                type="button"
                className={`header__nav-link ${
                  isActive ? "header__nav-link--active" : ""
                }`}
                onClick={() => handleNavigate(item.path)}
                aria-current={isActive ? "page" : undefined}
              >
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* Right side actions */}
        <div className="header__actions">

          <button
            type="button"
            className="header__action-button header__action-button--search"
            aria-label="Open search"
            onClick={onSidebarToggle}
          >
            Search
          </button>

          <button
            type="button"
            className="header__action-button header__action-button--phone"
            aria-label="Call CarbCareUSA"
            onClick={() => window.open("tel:+16197611113", "_self")}
          >
            Call
          </button>

        </div>

      </div>
    </header>
  );
}

export default Header;